module.exports = __webpack_public_path__ + "media/Images/icon-dollar-violet-99cbb6eecebe05417a93f9da8c0227bf.svg";